import { findSelectedOptionLabel, stringifyReferenceDataValue } from "./utils";
export const getFormattedMileage = (mileageSelection = -1, mileageData)=>{
    if (mileageSelection === -1) return "";
    return findSelectedOptionLabel(stringifyReferenceDataValue(mileageData), mileageSelection.toString());
};
